export default __webpack_public_path__ + "static/media/car.98d948e3.svg";